import { useTranslation } from "react-i18next";
import { Button } from "~/atoms/button";
import { useTiers } from "~/api/swr/useTiers";
import { useCategories } from "~/api/swr/useCategories";
import { useState } from "react";
import { Popover, PopoverContent, PopoverTrigger } from "~/atoms/popover";
import { NewDocumentForm } from "./NewDocumentForm";
import { ChevronDown } from "lucide-react";

export function NewDocumentButton() {
  const { t } = useTranslation();
  const { data: tiers } = useTiers();
  const { data: categories } = useCategories();
  const [open, setOpen] = useState(false);

  return (
    <Popover open={open} onOpenChange={setOpen}>
      <PopoverTrigger asChild>
        <Button>
          {t(($) => $.commons.create.document)}
          <ChevronDown />
        </Button>
      </PopoverTrigger>
      <PopoverContent className="w-[400px]" align="start">
        <NewDocumentForm categories={categories} tiers={tiers} />
      </PopoverContent>
    </Popover>
  );
}
